import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  private readonly unexpectedErrorSubject$ = new Subject<boolean>();
  readonly unexpectedError$ = this.unexpectedErrorSubject$.asObservable();
  readonly acceptedErrorCodes = [HttpStatusCode.InternalServerError, HttpStatusCode.RequestTimeout];
  showError() {
    this.unexpectedErrorSubject$.next(true);
  }
  closeError() {
    this.unexpectedErrorSubject$.next(false);
  }
}
